var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClip2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "-7 -7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.645 5.347l-6.738 6.738c-1.411 1.411-1.546 3.565-.3 4.811 1.247 1.246 3.4 1.113 4.812-.299l1.957-1.96 4.971-5 1.797-1.765a4.254 4.254 0 10-6.016-6.017L2.36 8.624m4.512 4.512l.975-.975 3.025-3.025 1.264-1.264a2.127 2.127 0 10-3.008-3.008l-.752.752",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgClip2;